<template>
  <div>
    <div class="mt-2 pl-3 pb-2 border-bottom">
      <b-button @click="$emit('close')" variant="transparent" class="mr-2 p-0 float-right">
        <img src="@/assets/icons/close.svg" class="icon icon-sm" />
      </b-button>

      <h5>Discussion's Settings</h5>
    </div>

    <div class="pt-2 pl-4 pr-4 pb-4">
      <h6 class="mt-4 w-100 text-uppercase font-poppins">
        Name
      </h6>

      <b-form-input v-model="localName" class="bg-white rounded border" />

      <h6 class="mt-4 w-100 text-uppercase font-poppins">
        Country
      </h6>
      <strong class="text-capitalize">{{ settings.country }}</strong>

      <h6 class="mt-4 w-100 text-uppercase font-poppins">
        SmartSearch
      </h6>

      <div class="cursor-pointer">
        <b-form-checkbox
          class="custom-checkbox cursor-pointer d-inline-block"
          switch
          size="lg"
          :value="true"
          :unchecked-value="false"
          v-model="localIsSmartSearch"
        />
        <strong @click="localIsSmartSearch = !localIsSmartSearch">
          SmartSearch
          <img src="@/assets/icons/smart-search.svg" class="ml-1" />
        </strong>

        <p @click="localIsSmartSearch = !localIsSmartSearch">
          <small>
            When SmartSearch is on, LegalAtlas will look into its entire corpus of documents to find the most appropriate answer.
            <br />
            When SmartSearch is off, you can specify to LegalAtlas where it should search.
          </small>
        </p>

        <b-row v-if="!localIsSmartSearch" class="border-top pt-3" no-gutters>
          <b-col v-for="o in FOCUS_OPTIONS" :key="o.value" cols="12" md="12">
            <focus-item :id="o.id" :name="o.name" :description="o.description" @handle-resources="handleResources" />
          </b-col>
        </b-row>

        <h6 class="mt-4 w-100 text-uppercase font-poppins">
          Attachments
        </h6>

        <attachments :attachments.sync="localAttachments" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { UPDATE } from "@/store/actions";

import { BRow, BCol, BFormInput, BFormCheckbox, BButton } from "bootstrap-vue";

import { FOCUS_OPTIONS } from "@/constants/settings";

import FocusItem from "../Task/Wizard/Focus/FocusItem";
import Attachments from "../Task/Wizard/Attachment/";

export default {
  name: "ChatSettings",
  components: { BRow, BCol, BFormCheckbox, BFormInput, BButton, FocusItem, Attachments },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    taskId: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      default: "",
    },
    settings: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    localName: {
      get() {
        return this.name;
      },
      set(name) {
        const { projectId, taskId } = this;
        this.updateTask({ projectId, taskId, name });
      },
    },
    localIsSmartSearch: {
      get() {
        return this.settings.isSmartSearch;
      },
      set(value) {
        const { projectId, taskId, settings } = this;
        settings.isSmartSearch = value;
        this.updateTask({ projectId, taskId, settings });
      },
    },
    localAttachments: {
      get() {
        return this.settings.attachments || [];
      },
      set(value) {
        const { projectId, taskId, settings } = this;
        console.log("val");
        console.log(value);
        settings.attachments = value;
        this.updateTask({ projectId, taskId, settings });
      },
    },
  },
  data: () => ({
    FOCUS_OPTIONS,
  }),
  created() {
    console.log("WOLO");
    console.log([...this.localAttachments]);
  },
  methods: {
    ...mapActions("projectsTasks", { updateTask: UPDATE }),
  },
};
</script>
